"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeechState = void 0;
/**
 * The state of SpeechContext.
 * @public
 */
var SpeechState;
(function (SpeechState) {
    /**
     * The context is in a state of unrecoverable error.
     * It is only possible to fix this by destroying and creating it from scratch.
     */
    SpeechState["Failed"] = "Failed";
    /**
     * Current browser is not supported by Speechly - it's not possible to use speech functionality.
     */
    SpeechState["NoBrowserSupport"] = "NoBrowserSupport";
    /**
     * The user did not provide permissions to use the microphone - it is not possible to use speech functionality.
     */
    SpeechState["NoAudioConsent"] = "NoAudioConsent";
    /**
     * The context has been created but not initialised. The audio and API connection are not enabled.
     */
    SpeechState["Idle"] = "Idle";
    /**
     * The context is connecting to the API.
     */
    SpeechState["Connecting"] = "Connecting";
    /**
     * The context is ready to use.
     */
    SpeechState["Ready"] = "Ready";
    /**
     * The context is current recording audio and sending it to the API for recognition.
     * The results are also being fetched.
     */
    SpeechState["Recording"] = "Recording";
    /**
     * The context is waiting for the API to finish sending trailing responses.
     * No audio is being sent anymore.
     */
    SpeechState["Loading"] = "Loading";
})(SpeechState = exports.SpeechState || (exports.SpeechState = {}));
//# sourceMappingURL=types.js.map